import React, { useState, useEffect } from "react";
import {
  Box,
  Container,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Button,
  Select,
  MenuItem,
  Menu,
  Checkbox,
  Typography,
  Tooltip,
  FormControl,
  InputLabel,
  IconButton,
  TextField,
  TableSortLabel,
  Autocomplete
} from "@mui/material";
import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { Link, NavLink } from "react-router-dom";
import { SPARE_LISTING_COLUMNS } from "../../utils/constant";
import RecordNotFound from "../../common/RecordNotFound";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";
import SpareView from "./SpareView";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Add from "@mui/icons-material/Add";
import DetailsIcon from "@mui/icons-material/Details";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import FilterAltOffSharpIcon from "@mui/icons-material/FilterAltOffSharp";
import download from "downloadjs";
import DownloadIcon from "@mui/icons-material/Download";
import { visuallyHidden } from "@mui/utils";
import useGlobalState from "../../Context";
import {
  setVendorSearch_, setActionSearch_, setBrandSearch_, setBrickSearch_, setPartTypeSearch_, setActiveSearch_, setSearchModelNameValue_, setSearchArticleCodeValue_, setSearchDescriptionValue_
} from "../../reducer/action";

const SpareSearchListing = (props) => {
  const {
    handleTableChanges,
    totalElements,
    spareRecords,
    fetchSpareDetails,
    statusList,
    partTypeList,
    brandListOnBrickId,
    brickListOnBrandId,
    fetchBrickListOnSelectedBrand,
    fetchBrandListOnSelectedBrick,
    onSearchSpareList,
    setLoading,
    showNotification,
    actionList,
    onAddSpareService,
    onEditSpareService,
    fetchSpareDetailsByIdService,
    setSpareRecords,
    SpareChangeStatusService,
    downloadSpareDetails,
    vendorList,
    noRecord,
    formData,
    setFormData,
    reset,
    searchedRows,
    vendorSearch,
    setVendorSearch,
    onClearClick,
    searchModelNameValue,
    setSearchModelNameValue,
    brandSearch,
    setBrandSearch,
    brickSearch,
    setBrickSearch,
    partTypeSearch,
    setPartTypeSearch,
    actionSearch,
    setActionSearch,
    statusSearch,
    activeSearch,
    setActiveSearch,
    searchArticleCodeValue,
    searchDescriptionValue,
    setSearchArticleCodeValue,
    setSearchDescriptionValue,
    disableFilterButton,
    disableSearchButton,
    setDisableSearchButton,
    setdisableFilterButton,
    disableDownloadButton,
    setDisableDownloadButton,
    value,
    setValue,
    page, setPage, maxPage, setMaxPage, rowsPerPage, setRowsPerPage,
    selected, setSelected, disableUpdateButton, setDisbaleUpdateButton,
    handleDeleteSpare

  } = props;
  // const [page, setPage] = useState(0);
  // const [maxPage, setMaxPage] = useState(0);
  // const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchwith, setSearchwith] = useState("");
  const [openAddSpareDialog, setOpenAddSpareDialog] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [warrantyValue, setWarrantyValue] = useState(null);
  const [spareId, setSpareId] = useState(null);
  const [rowClick, setRowClick] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  // const [selected, setSelected] = useState([]);
  // const [disableUpdateButton, setDisbaleUpdateButton] = useState(true);
  const [selectedRowForMenu, setSelectedRowForMenu] = useState(null);
  const [sortValue, setSortValue] = useState("ASC");
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("code");
  const [isSearchBtnClick, setIsSearchBtnClick] = useState(false);
  const [{ auth, spareAccessRights, vendorSearch_, actionSearch_, brandSearch_, brickSearch_, partTypeSearch_, activeSearch_, searchModelNameValue_, searchArticleCodeValue_, searchDescriptionValue_ }, dispatch] = useGlobalState();
  const loggedInUserInfo = auth.ldapParam;
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [rowToDelete, setRowToDelete] = useState(null);
  // const [vendorSearch_, setvendorSearch_] = useState(null);
  // const [actionSearch_, setactionSearch_] = useState(null);
  // const [brandSearch_, setbrandSearch_] = useState(null);
  // const [brickSearch_, setbrickSearch_] = useState(null);
  // const [partTypeSearch_, setpartTypeSearch_] = useState(null);
  // const [activeSearch_, setactiveSearch_] = useState(null);
  // const [searchModelNameValue_, setsearchModelNameValue_] = useState(null);
  // const [searchArticleCodeValue_, setsearchArticleCodeValue_] = useState(null);
  // const [searchDescriptionValue_, setsearchDescriptionValue_] = useState(null);

  const open = Boolean(anchorEl);
  //const inputRef = useRef(null);
  const inputRef = React.useRef();

  const handleClick = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowForMenu(row);
  };

  const openDeleteConfirm = (row) => {
    setRowToDelete(row);
    setConfirmDeleteOpen(true);
  };

  const handleCloseDeleteConfirm = () => {
    setConfirmDeleteOpen(false);
    setRowToDelete(null);
  };


  const handleMenuItem = (action) => {
    if (!selectedRowForMenu) return;

    switch (action) {
      case "view":
        handlspareListItem(null, "view");
        break;
      case "edit":
        handlspareListItem(null, "edit");
        break;
      case "detail":
        handlspareListItem(null, "detail");
        break;
      case "photo":
        handlspareListItem(null, "photo");
        break;
      case "modelInfo":
        handlspareListItem(null, "modelInfo");
        break;
      case "vendorInfo":
        handlspareListItem(null, "vendorInfo");
        break;
      case "suppliersInfo":
        handlspareListItem(null, "suppliersInfo");
        break;
      case "delete":
        openDeleteConfirm(selectedRowForMenu);
        break;
      default:
        break;
    }
    handleCloseMenu();
  };

  const handlspareListItem = (e, itemAction) => {
    const row = selectedRowForMenu;
    if (!row) return;
    
    setAnchorEl(null);
    if (itemAction === "view") {
      navigate(`/spare-search/spare-view`, {
        state: {
          code: row?.code,
          spareDescription: row?.spareDescription,
          spareId: row?.spareId,
        },
      });
    } else if (itemAction === "edit") {
      navigate("/spare-search/Edit-spare", {
        state: { id: row?.spareId, isEdit: true },
      });
    } else if (itemAction === "detail") {
      navigate(`/spare-search/spare-details`, {
        state: {
          spareId: row?.spareId,
          fromNotification: false
        },
      });
    } else if (itemAction === "photo") {
      navigate(`/spare-search/spare-photos`, {
        state: {
          code: row?.code,
          description: row?.spareDescription,
          spareId: row?.spareId,
        },
      });
    } else if (itemAction === "modelInfo") {
      navigate(`/spare-search/models-detail`, {
        state: {
          code: row?.code,
          spareDescription: row?.spareDescription,
          spareId: row?.spareId,
        },
      });
    } else if (itemAction === "vendorInfo") {
      navigate(`/spare-search/vendors-detail`, {
        state: {
          type: "VENDORS",
          code: row?.code,
          spareDescription: row?.spareDescription,
          spareId: row?.spareId,
        },
      });
    } else if (itemAction === "suppliersInfo") {
      navigate(`/spare-search/suppliers-detail`, {
        state: {
          type: "SUPPLIERS",
          code: row?.code,
          spareDescription: row?.spareDescription,
          spareId: row?.spareId,
        },
      });
    } else {
      console("error in spare extra listing menu");
    }
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
    setSelectedRowForMenu(null);
  };

  const [formValues, setFormValues] = useState({
    createdOn: new Date(),
    createdBy: auth?.ldapParam?.userId,
    modifiedBy: null,
  });
  const navigate = useNavigate();


  const fetchSpareById = async (id) => {
    try {
      const res = await fetchSpareDetailsByIdService(id);
      // if (res) {
      //   reset(res.data);
      // }

      if (res.statusCode == "6") {
        reset(res.data);
        setFormData(res.data);
        setWarrantyValue(res.data.warranty);
      } else {
        showNotification("Error", res.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      // setLoading(false);
    }
  };

  const handleClickOpen = async (item) => {
    if (item) {
      reset(item);
    }

    fetchSpareById(item?.spareId);
    setOpenAddSpareDialog(true);
    setIsEditMode(true);
    // setWarrantyValue(formData.warranty);
    setSpareId(item?.spareId);
    setFormValues({
      createdOn: item?.createdOn,
      createdBy: item?.createdBy,
    });
    setFormData(formData);
  };

  useEffect(() => {
    reset(formData);
  }, [openAddSpareDialog]);
  const handleClose = () => {
    setOpenAddSpareDialog(false);
    setIsEditMode(false);
    setFormData({});
  };

  const handleChangeRowsPerPage = async (event) => {
    const paginationValues = {
      pageNumber: 0,
      pageSize: +event.target.value,
    };
    await handleTableChanges(paginationValues, false, sortValue, orderBy, vendorSearch_, actionSearch_, brandSearch_, brickSearch_, partTypeSearch_, activeSearch_, searchModelNameValue_, searchArticleCodeValue_, searchDescriptionValue_);
    setPage(0);
    setMaxPage(0);
    setRowsPerPage(+event.target.value);
  };

  const handleChangePage = async (event, newPage) => {
    if (newPage > page && newPage > maxPage) {
      setMaxPage(newPage);
      const paginationValues = {
        pageNumber: newPage,
        pageSize: rowsPerPage,
      };
      await handleTableChanges(paginationValues, true, sortValue, orderBy, vendorSearch_, actionSearch_, brandSearch_, brickSearch_, partTypeSearch_, activeSearch_, searchModelNameValue_, searchArticleCodeValue_, searchDescriptionValue_);
    }
    setPage(newPage);
  };

  const onBrandClick = (id) => {
    setBrandSearch(id);
    fetchBrickListOnSelectedBrand(id);
    setDisableSearchButton(false);
    setdisableFilterButton(false);
  };

  const onBrickClick = (id) => {
    setBrickSearch(id);
    fetchBrandListOnSelectedBrick(id);
    setDisableSearchButton(false);
    setdisableFilterButton(false);
  };

  const onPartTypeClick = (id) => {
    setPartTypeSearch(id);
    setDisableSearchButton(false);
    setdisableFilterButton(false);
  };

  const searchText = async (e) => {
    setSearchModelNameValue(e.target.value);
    if (e.target.value.trim() === "" &&
      vendorSearch === null && actionSearch === null && brandSearch === null && brickSearch === null && partTypeSearch === null && activeSearch === null &&
      !searchDescriptionValue &&
      !searchArticleCodeValue) {
      setDisableSearchButton(true);
      setdisableFilterButton(true);
      setDisableDownloadButton(true);

    }

    if (
      e.target.value === "" &&
      vendorSearch === null && actionSearch === null && brandSearch === null && brickSearch === null && partTypeSearch === null && activeSearch === null &&
      !searchDescriptionValue &&
      !searchArticleCodeValue
    ) {
      onClearSpareListClick();
      // await fetchSpareDetails("code", true);
      // // eslint-disable-next-line no-unused-expressions
      // setPage(0);
      // setMaxPage(0);
      // setDisableSearchButton(true);
      // setdisableFilterButton(true);
      // setDisableDownloadButton(true);
    } else {
      if (e.target.value.trim().length > 0) {
        setDisableSearchButton(false);
        setdisableFilterButton(false);
      }
    }
  };

  const searchActicleCodeText = async (e) => {
    setSearchArticleCodeValue(e.target.value);
    if (e.target.value.trim() === "" &&
      vendorSearch === null && actionSearch === null && brandSearch === null && brickSearch === null && partTypeSearch === null && activeSearch === null &&
      !searchDescriptionValue &&
      !searchModelNameValue) {
      setDisableSearchButton(true);
      setdisableFilterButton(true);
      setDisableDownloadButton(true);

    }

    if (
      e.target.value === "" && vendorSearch === null && actionSearch === null && brandSearch === null && brickSearch === null && partTypeSearch === null && activeSearch === null &&
      !searchDescriptionValue && !searchModelNameValue
    ) {
      onClearSpareListClick();
      // await fetchSpareDetails("code", true);
      // // eslint-disable-next-line no-unused-expressions
      // setPage(0);
      // setMaxPage(0);
      // setDisableSearchButton(true);
      // setdisableFilterButton(true);
      // setDisableDownloadButton(true);
    } else {
      if (e.target.value.trim().length > 0) {
        setDisableSearchButton(false);
        setdisableFilterButton(false);
      }
    }
  };

  const searchDescriptionText = async (e) => {
    setSearchDescriptionValue(e.target.value);
    if (e.target.value.trim() === "" &&
      vendorSearch === null && actionSearch === null && brandSearch === null && brickSearch === null && partTypeSearch === null && activeSearch === null &&
      !searchModelNameValue &&
      !searchArticleCodeValue) {
      setDisableSearchButton(true);
      setdisableFilterButton(true);
      setDisableDownloadButton(true);

    }
    if (
      e.target.value === "" && vendorSearch === null && actionSearch === null && brandSearch === null && brickSearch === null && partTypeSearch === null && activeSearch === null &&
      !searchArticleCodeValue &&
      !searchModelNameValue
    ) {
      onClearSpareListClick();
      // await fetchSpareDetails("code", true);
      // // eslint-disable-next-line no-unused-expressions
      // setPage(0);
      // setMaxPage(0);
      // setDisableSearchButton(true);
      // setdisableFilterButton(true);
      // setDisableDownloadButton(true);
    } else {
      if (e.target.value.trim().length > 0) {
        setDisableSearchButton(false);
        setdisableFilterButton(false);
      }
    }
  };


  const searchOnClick = async (modelName, articleCode, description) => {
    try {
      setLoading(true);
      const spareRequestObj = {
        brandId: brandSearch ?? null,
        brickId: brickSearch ?? null,
        modelName: (modelName && modelName.trim()) ?? null,
        articleCode: (articleCode && articleCode.trim()) ?? null,
        description: (description && description.trim()) ?? null,
        status: statusSearch ?? null,
        partTypeId: partTypeSearch ?? null,
        pageNumber: 0,
        pageSize: rowsPerPage ?? 10,

        vendorId: vendorSearch ?? null,
        defActionId: actionSearch ?? null,
        active: activeSearch ?? null,
        sortDirection: "ASC",
        sortBy: "code",
      };
      // setvendorSearch_(vendorSearch);
      // setactionSearch_(actionSearch);
      // setbrandSearch_(brandSearch);
      // setbrickSearch_(brickSearch);
      // setpartTypeSearch_(partTypeSearch);
      // setactiveSearch_(activeSearch);
      // setsearchModelNameValue_(searchModelNameValue);
      // setsearchArticleCodeValue_(searchArticleCodeValue);
      // setsearchDescriptionValue_(searchDescriptionValue);

      dispatch(setVendorSearch_(vendorSearch));
      dispatch(setActionSearch_(actionSearch));
      dispatch(setBrandSearch_(brandSearch));
      dispatch(setBrickSearch_(brickSearch));
      dispatch(setPartTypeSearch_(partTypeSearch));
      dispatch(setActiveSearch_(activeSearch));
      dispatch(setSearchModelNameValue_(searchModelNameValue));
      dispatch(setSearchArticleCodeValue_(searchArticleCodeValue));
      dispatch(setSearchDescriptionValue_(searchDescriptionValue));


      setSelected([]);
      setDisbaleUpdateButton(true)
      setPage(0);
      setMaxPage(0);
      if (searchedRows && searchedRows.length > 0) {
        setDisableDownloadButton(false);
      }
      setIsSearchBtnClick(true);
      const responseCount = await onSearchSpareList(spareRequestObj);
      if (responseCount > 0) {
        setDisableDownloadButton(false);
      } else {
        setDisableDownloadButton(true);
      }
    } catch (err) {
      showNotification("Error", err.message ?? "Failed to fetch user details");
    } finally {
      setLoading(false);
    }
    setSearchwith(modelName && modelName.trim());
  };
  const onClearSpareListClick = () => {
    const paginationData = {
      pageNumber: 0,
      pageSize: rowsPerPage ?? 10,
    };
    // setvendorSearch_(null);
    // setactionSearch_(null);
    // setbrandSearch_(null);
    // setbrickSearch_(null);
    // setpartTypeSearch_(null);
    // setactiveSearch_(null);
    // setsearchModelNameValue_(null);
    // setsearchArticleCodeValue_(null);
    // setsearchDescriptionValue_(null);
    dispatch(setVendorSearch_(null));
    dispatch(setActionSearch_(null));
    dispatch(setBrandSearch_(null));
    dispatch(setBrickSearch_(null));
    dispatch(setPartTypeSearch_(null));
    dispatch(setActiveSearch_(null));
    dispatch(setSearchModelNameValue_(null));
    dispatch(setSearchArticleCodeValue_(null));
    dispatch(setSearchDescriptionValue_(null));
    setSearchModelNameValue(null); setSearchArticleCodeValue(null); setSearchDescriptionValue(null)
    setPage(0);
    setMaxPage(0);
    setIsSearchBtnClick(false);
    setSelected([]);
    setDisbaleUpdateButton(true)
    setDisableDownloadButton(true);
    onClearClick(paginationData);

  };
  const isSelected = (name) => selected.indexOf(name) !== -1;

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - spareRecords.length) : 0;

  const handleActiveChange = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
    if (newSelected.length !== 0) {
      setDisbaleUpdateButton(false);
    } else {
      setDisbaleUpdateButton(true);
    }
    const newSearchedRow = spareRecords.map((currentRow) => {
      if (currentRow.spareId === id) {
        return {
          ...currentRow,
          active: event.target.checked,
        };
      }
      return currentRow;
    });
    setSpareRecords(newSearchedRow);
  };

  const onChangeStatusSubmit = async () => {
    const resultRecords = [];
    selected.forEach((itemId) => {
      const tempItem = spareRecords.find((record) => record.spareId === itemId);
      if (tempItem) {
        resultRecords.push({
          active: tempItem.active,
          spareId: tempItem.spareId,
        });
      }
    });
    try {
      const res = await SpareChangeStatusService(resultRecords);
      if (res.statusCode === 6) {
        // await fetchSpareDetails("code", true);
        setSelected([]);
        setDisbaleUpdateButton(true);
        showNotification("Success", res.message, "success");
      } else {
        showNotification("Error", res.message, "error");
      }
    } catch (e) {
    } finally {
    }
  };

  const handleRequestSort = async (event, property) => {
    const paginationValues = {
      pageNumber: 0,
      pageSize: rowsPerPage,
    };
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    setSelected([]);
    setDisbaleUpdateButton(true)
    fetchSpareDetails(property, isAsc, vendorSearch_, actionSearch_, brandSearch_, brickSearch_, partTypeSearch_, activeSearch_, searchModelNameValue_, searchArticleCodeValue_, searchDescriptionValue_, paginationValues);
    setSortValue(isAsc ? "DESC" : "ASC");
    setPage(0);
    setMaxPage(0);

  };

  return (
    <>
      <Container maxWidth="lg" sx={{ mt: 8 }}>
        {/* <Paper elevation={4} sx={{ width: "100%", overflow: "hidden" }}> */}
        <Grid container spacing={0} sx={{ px: 0, mt: 0 }} display="flex">
          <Grid item xs={4} sx={{ mb: 1 }}>
            <Typography
              align="left"
              sx={{ mr: "auto", color: "#003f93" }}
              variant="h6"
            >
              Spare Search ( {totalElements ? totalElements : 0} )
            </Typography>
          </Grid>
          <Grid item xs={8} sx={{ mb: 1 }}>
            <Typography align="right">
              {spareAccessRights.addDelete ? (
                <Tooltip title="Add Spare">
                  <Button
                    variant="contained"
                    onClick={() => {
                      //handleClickOpenOnAdd();
                      navigate("/spare-search/add-spare", { state: { fromModel: false } });
                    }}
                    sx={{ ml: 1 }}
                    className="button-primary-alt-contained"
                    startIcon={<Add />}
                  >
                    Add Spare
                  </Button>
                </Tooltip>
              ) : null}
              {//loggedInUserInfo.rilUser ? (
                <Tooltip title="Download Spare Details">
                  <Button
                    variant="contained"
                    className="button-primary-alt-contained"
                    startIcon={<DownloadIcon />}
                    //disabled={disableDownloadButton}
                    sx={{ ml: 1 }}
                    onClick={async () => {
                      try {
                        setLoading(true);
                        const obj = {
                          brandId: brandSearch_,
                          brickId: brickSearch_,
                          modelName: searchModelNameValue_ && searchModelNameValue_.trim(),
                          articleCode: searchArticleCodeValue_ && searchArticleCodeValue_.trim(),
                          description: searchDescriptionValue_ && searchDescriptionValue_.trim(),
                          active: activeSearch_,
                          status: activeSearch_,
                          partTypeId: partTypeSearch_,
                          vendorId: vendorSearch_,
                          defActionId: actionSearch_,
                        };

                        const response = await downloadSpareDetails(obj);
                        const content = response.headers["content-type"];
                        download(response.data, "spareList.csv", content);
                      } catch (err) {
                        showNotification("Error", "Failed To Fetch");
                      } finally {
                        setLoading(false);
                      }
                    }}
                  >
                    Download
                  </Button>
                </Tooltip>
                //) : null
              }
              {spareAccessRights.addDelete ? (
                <Tooltip title="Update User Status">
                  <Button
                    variant="contained"
                    sx={{ ml: 1 }}
                    className="button-primary-alt-contained"
                    onClick={onChangeStatusSubmit}
                    disabled={disableUpdateButton}
                  >
                    Status Update
                    {selected.length !== 0 &&
                      ` (${Object.keys(selected).length})`}
                  </Button>
                </Tooltip>
              ) : null}
            </Typography>
          </Grid>

          <Grid container spacing={1} sx={{ px: 0, mt: 0 }} display="flex">
            {loggedInUserInfo.department.toLowerCase() === "D & L".toLowerCase() ||
              // loggedInUserInfo.department === "FQS".toLowerCase() ||
              // loggedInUserInfo.department === "resQ SPM".toLowerCase() ||
              loggedInUserInfo.userType === "Main Admin" ? (
              <Grid item xs={2} md={2}>
                <FormControl sx={{ m: 0, minWidth: 150 }} size="small">
                  <InputLabel
                    id="demo-simple-select-label"
                    shrink={
                      vendorSearch === null || (vendorSearch !== null && true)
                    }
                  >
                    <span className="searchFields"> Vendor </span>
                  </InputLabel>
                  <Select
                    name="id"
                    label="Vendor"
                    autoComplete="off"
                    // {...register("vendorId")}
                    value={vendorSearch}
                  >
                    {vendorList &&
                      vendorList.map((d) => {
                        return (
                          <MenuItem
                            native
                            key={d.vendorId}
                            sx={{ width: "100%" }}
                            value={d.vendorId}
                            size="small"
                            onClick={() => {
                              setVendorSearch(d.vendorId);
                              setDisableSearchButton(false);
                              setdisableFilterButton(false);
                            }}
                          >
                            {d.name}
                          </MenuItem>
                        );
                      })}
                  </Select>
                </FormControl>
              </Grid>
            ) : null}
            {loggedInUserInfo.department.toLowerCase() === "D & L".toLowerCase() ||
              loggedInUserInfo.userType === "Main Admin" ? (
              <Grid item xs={2} md={2}>
                <FormControl sx={{ m: 0, minWidth: 150 }} size="small">
                  <InputLabel
                    id="demo-simple-select-label"
                    shrink={
                      actionSearch === null || (actionSearch !== null && true)
                    }
                  >
                    <span className="searchFields"> Action </span>
                  </InputLabel>
                  <Select
                    name="id"
                    label="Action"
                    autoComplete="off"
                    // {...register("defSpareActionId")}
                    value={actionSearch}
                  >
                    {actionList &&
                      actionList.map((d) => {
                        return (
                          <MenuItem
                            native
                            key={d.defSpareActionId}
                            sx={{ width: "100%" }}
                            value={d.defSpareActionId}
                            size="small"
                            onClick={() => {
                              setActionSearch(d.defSpareActionId);
                              setDisableSearchButton(false);
                              setdisableFilterButton(false);
                            }}
                          >
                            {d.name}
                          </MenuItem>
                        );
                      })}
                  </Select>
                </FormControl>
              </Grid>
            ) : null}
            <Grid item xs={2} md={2}>
              <FormControl sx={{ m: 0, minWidth: 150 }} size="small">
                <InputLabel
                  id="demo-simple-select-label"
                  shrink={
                    brandSearch === null || (brandSearch !== null && true)
                  }
                >
                  <span className="searchFields"> Brand </span>
                </InputLabel>
                <Select
                  name="id"
                  label="Brand"
                  autoComplete="off"
                  value={brandSearch}
                >
                  {brandListOnBrickId &&
                    brandListOnBrickId.map((d) => {
                      return (
                        <MenuItem
                          native
                          key={d.brandId}
                          onClick={() => onBrandClick(d.brandId)}
                          sx={{ width: "100%" }}
                          value={d.brandId}
                          size="small"
                        >
                          {d.name}
                        </MenuItem>
                      );
                    })}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={2} md={2}>
              <FormControl sx={{ m: 0, minWidth: 150 }} size="small">
                <InputLabel
                  id="demo-simple-select-label"
                  shrink={
                    brickSearch === null || (brickSearch !== null && true)
                  }
                >
                  <span className="searchFields"> Brick </span>
                </InputLabel>
                <Select
                  name="brickId"
                  autoComplete="off"
                  label="Brick"
                  value={brickSearch}
                >
                  {brickListOnBrandId &&
                    brickListOnBrandId.map((d) => {
                      return (
                        <MenuItem
                          native
                          key={d.brickId}
                          onClick={() => onBrickClick(d.brickId)}
                          sx={{ width: "100%" }}
                          value={d.brickId}
                          size="small"
                        >
                          {d.brickName}
                        </MenuItem>
                      );
                    })}
                </Select>
              </FormControl>
            </Grid>
            {loggedInUserInfo.department === "D&L".toUpperCase() ||
              loggedInUserInfo.userType === "Main Admin" ? (
              <Grid item xs={2} md={2}>
                <FormControl className="partTypeBlock" sx={{ m: 0, minWidth: 150 }} size="small">
                  <InputLabel
                    id="demo-simple-select-label"
                    shrink={
                      partTypeSearch === null ||
                      (partTypeSearch !== null && true)
                    }
                  >
                    <span className="searchFields"> Part Type </span>
                  </InputLabel>
                  <Autocomplete
                    value={value}
                    size="small"
                    // freeSolo
                    // id="free-solo-2-demo"
                    clearText='Clear'
                    onChange={(event, newValue, reason) => {
                      onPartTypeClick(newValue?.partTypeId);
                      // console.log('reason',reason)
                      setValue(newValue);
                      // console.log('value',value)
                      if (reason === "clear") {
                        fetchSpareDetails("code", true);
                        setPage(0);
                        setMaxPage(0);
                        setDisableSearchButton(true);
                        setdisableFilterButton(true);
                        setDisableDownloadButton(true);
                      }
                      else {
                        setDisableSearchButton(false);
                        setdisableFilterButton(false);
                      }

                    }}
                    options={localStorage.getItem('partTypeListItem') ? JSON.parse(localStorage.getItem('partTypeListItem')) : ''}
                    getOptionLabel={(option) => option?.name ? option.name : ''}

                    renderInput={(params) => (
                      <TextField
                        {...params}
                        InputProps={{
                          ...params.InputProps,

                        }}
                      />
                    )}
                  />
                </FormControl>

              </Grid>
            ) : null}
            {spareAccessRights.addDelete && spareAccessRights.write ? (
              <Grid item xs={2} md={2}>
                <FormControl sx={{ m: 0, minWidth: 150 }} size="small">
                  <InputLabel
                    id="demo-simple-select-label"
                    shrink={
                      activeSearch === null || (activeSearch !== null && true)
                    }
                  >
                    <span className="searchFields">Status</span>
                  </InputLabel>
                  <Select
                    className="stepperFormInput"
                    label="Is Active?"
                    autoComplete="off"
                    value={activeSearch}
                  >
                    <MenuItem
                      native
                      sx={{ width: "100%" }}
                      value={0}
                      size="small"
                      onClick={() => {
                        setActiveSearch(0);
                        setDisableSearchButton(false);
                        setdisableFilterButton(false);
                      }}
                    >
                      Yes
                    </MenuItem>
                    <MenuItem
                      native
                      sx={{ width: "100%" }}
                      value={1}
                      size="small"
                      onClick={() => {
                        setActiveSearch(1);
                        setDisableSearchButton(false);
                        setdisableFilterButton(false);
                      }}
                    >
                      No
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            ) : null}
            <Grid item xs={2} md={2}>

              <FormControl sx={{ m: .5, minWidth: 150 }} size="small">
                <TextField
                  className="stepperFormInput"
                  label="Model Name"
                  onChange={searchText}
                  InputLabelProps={{ shrink: true }}
                  value={searchModelNameValue}
                  size="small"
                  autoComplete="off"
                  onBlur={(e) => {
                    let str = e.target.value;
                    setSearchModelNameValue(str.trim());
                    if (str.trim().length <= 0 &&
                      vendorSearch === null && actionSearch === null && brandSearch === null && brickSearch === null && partTypeSearch === null && activeSearch === null &&
                      !searchDescriptionValue &&
                      !searchArticleCodeValue) {
                      setDisableSearchButton(true);
                      setdisableFilterButton(true);
                      setDisableDownloadButton(true);
                    }
                  }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={2} md={2}>

              <FormControl sx={{ m: .5, minWidth: 150 }} size="small">
                <TextField
                  className="stepperFormInput"
                  label="Article"
                  onChange={searchActicleCodeText}
                  InputLabelProps={{ shrink: true }}
                  value={searchArticleCodeValue}
                  size="small"
                  autoComplete="off"
                  onBlur={(e) => {
                    let str = e.target.value;
                    setSearchArticleCodeValue(str.trim());
                    if (str.trim().length <= 0 &&
                      vendorSearch === null && actionSearch === null && brandSearch === null && brickSearch === null && partTypeSearch === null && activeSearch === null &&
                      !searchDescriptionValue &&
                      !searchModelNameValue) {
                      setDisableSearchButton(true);
                      setdisableFilterButton(true);
                      setDisableDownloadButton(true);
                    }
                  }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={2} md={2}>


              <FormControl sx={{ m: .5, minWidth: 150 }} size="small">
                <TextField
                  className="stepperFormInput"
                  label="Description"
                  onChange={searchDescriptionText}
                  InputLabelProps={{ shrink: true }}
                  value={searchDescriptionValue}
                  size="small"
                  autoComplete="off"
                  onBlur={(e) => {
                    let str = e.target.value;
                    setSearchDescriptionValue(str.trim());
                    if (str.trim().length <= 0 &&
                      vendorSearch === null && actionSearch === null && brandSearch === null && brickSearch === null && partTypeSearch === null && activeSearch === null &&
                      !searchModelNameValue &&
                      !searchArticleCodeValue) {
                      setDisableSearchButton(true);
                      setdisableFilterButton(true);
                      setDisableDownloadButton(true);
                    }
                  }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={2} md={2}>
              <Tooltip title="Search">
                <IconButton
                  color="primary"
                  aria-label="Search"
                  component="label"
                  disabled={disableSearchButton}
                >
                  <SearchIcon
                    sx={{ height: "35px", width: "35px" }}
                    onClick={() =>
                      searchOnClick(
                        searchModelNameValue,
                        searchArticleCodeValue,
                        searchDescriptionValue
                      )
                    }
                  />
                </IconButton>
              </Tooltip>
              <Tooltip title="Clear Search">
                <IconButton
                  color="primary"
                  aria-label="Clear"
                  component="label"
                  disabled={disableFilterButton}
                >
                  <FilterAltOffSharpIcon
                    sx={{ height: "32px", width: "32px" }}
                    onClick={() => { onClearSpareListClick(); setPage(0); setValue('') }}
                  />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
          <Grid item xs={12} mb={4}>
            <Paper sx={{ width: "100%", overflow: "hidden" }}>
              <TableContainer sx={{ maxHeight: 720 }}>
                <Table
                  stickyHeader
                  aria-label="sticky table"
                  aria-labelledby="tableTitle"
                  size="small"
                >
                  <EnhancedTableHead
                    numSelected={selected.length}
                    rowCount={searchedRows.length}
                    onRequestSort={handleRequestSort}
                    order={order}
                    orderBy={orderBy}
                    spareAccessRights={spareAccessRights}
                  />

                  {searchedRows && searchedRows.length > 0 ? (
                    <TableBody sx={{ mt: 2 }}>
                      {searchedRows
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row, index) => {
                          const isItemSelected = isSelected(row.spareId);
                          const labelId = `enhanced-table-checkbox-${index}`;
                          return (
                            <TableRow
                              hover
                              tabIndex={-1}
                              role="checkbox"
                              aria-checked={isItemSelected}
                              selected={isItemSelected}
                              key={row.spareId}
                            >
                              <TableCell sx={{ cursor: 'pointer' }} width="15%" size="small" key={"code"} onClick={() => {
                                navigate(`/spare-search/spare-details`, {
                                  state: {
                                    spareId: row?.spareId,
                                    fromNotification: false
                                  },
                                });
                              }}>
                                <Link style={{ color: '#567AAC', backgroundcolor: 'transparent', fontweight: 'bold' }} to=""> {`${row["code"]}` ?? "-"}</Link>
                              </TableCell>
                              <TableCell
                                size="small"
                                key={"spareDescription"}
                                title={
                                  row.spareDescription
                                    ? row.spareDescription
                                    : ""
                                }
                                width="20%"
                              >
                                {(row.spareDescription &&
                                  row.spareDescription?.slice(0, 35)) ||
                                  "-"}
                                {row.spareDescription &&
                                  row.spareDescription.length > 35
                                  ? "..."
                                  : ""}{" "}
                              </TableCell>
                              <TableCell
                                width="15%"
                                size="medium"
                                key={"brandName"}
                              >
                                {row["brandName"] ?? "-"}
                              </TableCell>
                              <TableCell
                                width="15%"
                                size="medium"
                                key={"brickName"}
                              >
                                {row["brickName"] ?? "-"}
                              </TableCell>
                              <TableCell
                                width="15%"
                                size="medium"
                                key={"partName"}
                                title={row?.partName ? row.partName : ""}
                              >
                                {(row.partName &&
                                  row.partName?.slice(0, 20)) ||
                                  "-"}
                                {row.partName && row.partName.length > 20
                                  ? "..."
                                  : ""}
                                {/* {row["partName"] ?? "-"} */}
                              </TableCell>
                              <TableCell
                                width="15%"
                                size="medium"
                                key={"defSpareActionName"}
                              >
                                {row["defSpareActionName"] ?? "-"}
                              </TableCell>
                              <TableCell
                                size="medium"
                                key={"hasAlternateSpare"}
                              >
                                {(row["hasAlternateSpare"] ? "Yes" : "No") ??
                                  "-"}
                              </TableCell>
                              {spareAccessRights.addDelete ? (
                                <TableCell width="1%" align="center">
                                  {" "}
                                  <Checkbox
                                    color="primary"
                                    checked={(isItemSelected, row.active)}
                                    classes={{ root: 'custom-checkbox-root' }}
                                    onChange={(event) =>
                                      handleActiveChange(event, row.spareId)
                                    }
                                    onClick={(e) => e.stopPropagation()}
                                    inputProps={{
                                      "aria-labelledby": labelId,
                                    }}
                                  />
                                </TableCell>
                              ) : null}
                              <TableCell width="1%">
                                <MoreVertIcon
                                  onClick={(event) => {
                                    handleClick(event, row);
                                  }}
                                  fontSize="small"
                                  cursor="pointer"
                                />
                                <Menu
                                  id="basic-menu"
                                  className="listingPopOver"
                                  anchorEl={anchorEl}
                                  open={open}
                                  onClose={handleCloseMenu}
                                  MenuListProps={{
                                    "aria-labelledby": "basic-button",
                                  }}
                                >
                                  <MenuItem onClick={() => handleMenuItem("view")}>
                                    <VisibilityIcon fontSize="medium" color="disabled" sx={{ mr: 1 }} />
                                    Alternate Spares
                                  </MenuItem>

                                  {spareAccessRights.write ? (
                                    <MenuItem onClick={() => handleMenuItem("edit")}>
                                      <EditIcon fontSize="medium" color="disabled" sx={{ mr: 1 }} />
                                      Edit
                                    </MenuItem>
                                  ) : null}

                                  <MenuItem onClick={() => handleMenuItem("detail")}>
                                    <DetailsIcon fontSize="medium" color="disabled" sx={{ mr: 1 }} />
                                    Spare Details
                                  </MenuItem>

                                  <MenuItem onClick={() => handleMenuItem("photo")}>
                                    <AddPhotoAlternateIcon fontSize="medium" color="disabled" sx={{ mr: 1 }} />
                                    Spare Photo
                                  </MenuItem>

                                  <MenuItem onClick={() => handleMenuItem("modelInfo")}>
                                    <VisibilityIcon fontSize="medium" color="disabled" sx={{ mr: 1 }} />
                                    Models Detail
                                  </MenuItem>

                                  {loggedInUserInfo.department.toLowerCase() === "d & l".toLowerCase() ||
                                    loggedInUserInfo.userType === "Main Admin" ? (
                                    <MenuItem onClick={() => handleMenuItem("vendorInfo")}>
                                      <VisibilityIcon fontSize="medium" color="disabled" sx={{ mr: 1 }} />
                                      Vendors Detail
                                    </MenuItem>
                                  ) : null}

                                  {loggedInUserInfo.department.toLowerCase() === "d & l".toLowerCase() ||
                                    loggedInUserInfo.userType === "Main Admin" ? (
                                    <MenuItem onClick={() => handleMenuItem("suppliersInfo")}>
                                      <VisibilityIcon fontSize="medium" color="disabled" sx={{ mr: 1 }} />
                                      Suppliers Detail
                                    </MenuItem>
                                  ) : null}

                                  {(loggedInUserInfo.userType === "Main Admin" ||
                                    loggedInUserInfo.userType === "Domain Admin") &&
                                    spareAccessRights.addDelete && (
                                      <MenuItem onClick={() => handleMenuItem("delete")}>
                                        <DeleteIcon fontSize="medium" color="disabled" sx={{ mr: 1 }} />
                                        Delete
                                      </MenuItem>
                                    )}
                                </Menu>
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      {emptyRows > 0 && (
                        <TableRow
                          style={{
                            height: 33 * emptyRows,
                          }}
                        >
                          <TableCell colSpan={8} />
                        </TableRow>
                      )}
                    </TableBody>
                  ) : (
                    <TableBody>
                      <TableRow>
                        {noRecord ? (
                          <TableCell colSpan={8}>
                            <RecordNotFound />
                          </TableCell>
                        ) : (
                          <TableCell colSpan={8} />
                        )}
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
              {searchedRows && searchedRows.length > 0 ? (
                <TablePagination
                  className="newPagination"
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  component="div"
                  count={totalElements}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              ) : null}
            </Paper>

            {rowClick ? (
              <SpareView
                showNotification={showNotification}
                statusList={statusList}
                brandListOnBrickId={brandListOnBrickId}
                onSearchSpareList={onSearchSpareList}
                fetchBrickListOnSelectedBrand={fetchBrickListOnSelectedBrand}
                fetchBrandListOnSelectedBrick={fetchBrandListOnSelectedBrick}
                partTypeList={partTypeList}
                brickListOnBrandId={brickListOnBrandId}
              />
            ) : null}
          </Grid>
        </Grid>
        {/* </Paper> */}
        <Dialog
          open={confirmDeleteOpen}
          onClose={handleCloseDeleteConfirm}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle
            sx={{ bgcolor: "primary.main", color: "primary.contrastText", py: 1.5 }}
          >
            Confirm Delete
          </DialogTitle>
          <DialogContent dividers>
            Are you sure you want to delete this spare?
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDeleteConfirm} variant="outlined">
              Cancel
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={() => {
                if (rowToDelete) {
                  handleDeleteSpare(rowToDelete);
                }
                handleCloseDeleteConfirm();
              }}
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </>
  );
};

export default SpareSearchListing;

function EnhancedTableHead({
  onRequestSort,
  order,
  orderBy,
  spareAccessRights,
}) {
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  return (
    <TableHead>
      <TableRow key={"1"}>
        {SPARE_LISTING_COLUMNS.map((headCell) => (
          <TableCell
            size="small"
            variant="head"
            className="tableHeader1"
            sx={{ pt: 1.5, pb: 1.5 }}
            key={headCell.spareId}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            style={{
              minWidth: headCell.minWidth,
              fontWeight: "bold",
              color: "#003A6B",
            }}
            sortDirection={orderBy === headCell.id ? order : false}
            hidden={
              spareAccessRights.addDelete === false
                ? headCell.id === "active"
                  ? true
                  : false
                : false
            }
          >
            <TableSortLabel
              active={
                headCell.id === "action" ||
                  headCell.id === "active" ||
                  headCell.id === "brickName" ||
                  headCell.id === "brandName" ||
                  headCell.id === ""
                  ? false
                  : orderBy === headCell.id
              }
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
              hideSortIcon={
                (headCell.id === "action" ||
                  headCell.id === "active" ||
                  headCell.id === "brickName" ||
                  headCell.id === "brandName" ||
                  headCell.id === "") &&
                true
              }
              disabled={
                (headCell.id === "action" ||
                  headCell.id === "active" ||
                  headCell.id === "brandName" ||
                  headCell.id === "brickName") &&
                true
              }
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
